import React from 'react';

export const GeosHeader = (props) => {
    return(
        <div className="header">
            <h2>Liste des Géolocalisation</h2>
        </div>
    )
};
